(function () {
  if (window.__cvInit) return;
  window.__cvInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function observar(el) {
    if (!('IntersectionObserver' in window) || reduce) { el.classList.add('cv-visible'); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('cv-visible');
            if (e.target.__cvAlVer) e.target.__cvAlVer();
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
    }
    observador.observe(el);
  }

  function initReveals(raiz) {
    raiz.querySelectorAll('.cv-reveal, [data-cv-observar]').forEach(function (el) {
      if (el.dataset.cvObs) return;
      el.dataset.cvObs = '1';
      observar(el);
    });
  }

  function initHero(raiz) {
    raiz.querySelectorAll('.cv-hero').forEach(function (h) {
      if (h.dataset.cvInit) return;
      h.dataset.cvInit = '1';
      requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('cv-cargado'); }); });
    });
  }

  function initHotspots(raiz) {
    raiz.querySelectorAll('[data-cv-hotspots]').forEach(function (s) {
      if (s.dataset.cvInit) return;
      s.dataset.cvInit = '1';
      var puntos = s.querySelectorAll('.cv-hs__punto');
      var items = s.querySelectorAll('.cv-hs__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('cv-activo', i === j); p.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        items.forEach(function (p, j) { p.classList.toggle('cv-activo', i === j); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      items.forEach(function (p, i) {
        p.addEventListener('click', function () { activar(i); });
        p.addEventListener('mouseenter', function () { activar(i); });
      });
      activar(0);
    });
  }

  function contar(el, hasta, duracion) {
    if (reduce) { el.textContent = hasta; return; }
    var inicio = null;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / duracion, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(hasta * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  function initMinutos(raiz) {
    raiz.querySelectorAll('[data-cv-minutos]').forEach(function (s) {
      if (s.dataset.cvInit) return;
      s.dataset.cvInit = '1';
      var circulo = s.querySelector('.cv-min__progreso');
      var num = s.querySelector('[data-cv-contar]');
      var pct = parseFloat(s.getAttribute('data-cv-minutos')) || 70;
      var r = parseFloat(circulo.getAttribute('r'));
      var largo = 2 * Math.PI * r;
      circulo.style.strokeDasharray = largo;
      circulo.style.strokeDashoffset = largo;
      s.__cvAlVer = function () {
        circulo.style.strokeDashoffset = largo * (1 - pct / 100);
        if (num) contar(num, parseInt(num.getAttribute('data-cv-contar'), 10) || 0, 1800);
      };
      if (reduce) s.__cvAlVer();
      else if (!s.dataset.cvObs) { s.dataset.cvObs = '1'; observar(s); }
    });
  }

  function initFaq(raiz) {
    raiz.querySelectorAll('.cv-faq__item').forEach(function (it) {
      if (it.dataset.cvInit) return;
      it.dataset.cvInit = '1';
      var btn = it.querySelector('.cv-faq__pregunta');
      btn.addEventListener('click', function () {
        var abierto = it.classList.toggle('cv-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initMagnetico(raiz) {
    if (window.matchMedia('(hover: none)').matches || reduce) return;
    raiz.querySelectorAll('[data-cv-magnetico]').forEach(function (b) {
      if (b.dataset.cvInit) return;
      b.dataset.cvInit = '1';
      var zona = b.parentElement;
      zona.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 160) b.style.transform = 'translate(' + (dx * 0.06).toFixed(1) + 'px,' + (dy * 0.08).toFixed(1) + 'px)';
        else b.style.transform = '';
      });
      zona.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  function initProducto(raiz) {
    raiz.querySelectorAll('[data-cv-producto]').forEach(function (s) {
      if (s.dataset.cvInit) return;
      s.dataset.cvInit = '1';
      var principal = s.querySelector('.cv-pdp__principal img');
      var minis = s.querySelectorAll('.cv-pdp__mini');
      function mostrar(src, srcset, alt) {
        if (!principal || !src) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset');
          if (alt) principal.alt = alt;
          principal.style.opacity = '1';
        }, 160);
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          minis.forEach(function (x) { x.classList.remove('cv-activo'); });
          m.classList.add('cv-activo');
          mostrar(m.dataset.src, m.dataset.srcset, m.dataset.alt);
        });
      });

      var datos = s.querySelector('[data-cv-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = s.querySelector('form[action*="/cart/add"]');
      var inputId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[name="add"]');
      var precio = s.querySelector('[data-cv-precio]');
      var tachado = s.querySelector('[data-cv-tachado]');
      var textoBoton = boton.getAttribute('data-texto');
      var textoAgotado = boton.getAttribute('data-agotado');
      var formato = s.getAttribute('data-cv-moneda') || '{{amount_with_comma_separator}} €';

      function dinero(c) {
        var v = (c / 100).toFixed(2);
        var coma = v.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma).replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar() {
        var elegidas = [];
        s.querySelectorAll('.cv-pdp__opcion').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          elegidas.push(c ? c.value : null);
          var etiqueta = fs.querySelector('legend span');
          if (etiqueta && c) etiqueta.textContent = c.value;
        });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; return; }
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else tachado.hidden = true;
        }
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        if (v.featured_image && v.featured_image.src) mostrar(v.featured_image.src, null, v.featured_image.alt);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
        }
      }
      s.querySelectorAll('.cv-pdp__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

      var cant = s.querySelector('.cv-pdp__cantidad input');
      s.querySelectorAll('[data-cv-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.cvCant, 10);
          cant.value = Math.max(1, n);
        });
      });
    });
  }

  function initTodo(e) {
    var raiz = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initHero(raiz);
    initReveals(raiz);
    initHotspots(raiz);
    initMinutos(raiz);
    initFaq(raiz);
    initMagnetico(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
